import apiClient from './api.service';
import { CentreCall } from './centre.service';

export interface VoipStatus {
  enabled: boolean;
  provider?: 'telnyx' | 'sip' | null;
  from_number: string | null;
  recording: boolean;
}

export interface VoipToken {
  provider?: 'telnyx' | 'sip';
  token?: string;
  sip_username?: string;
  sip_uri?: string;
  sip_domain?: string;
  sip_password?: string;
  websocket_url?: string;
  ice_servers?: Array<{ urls: string; username?: string; credential?: string }>;
  caller_id: string;
  recording: boolean;
}

const centreVoipService = {
  async getStatus(storeId: number) {
    const response = await apiClient.get<{ success: boolean; data: VoipStatus }>(
      `/stores/${storeId}/centre/voip/status`
    );
    return response.data.data;
  },

  async getToken(storeId: number) {
    const response = await apiClient.get<{ success: boolean; data: VoipToken }>(
      `/stores/${storeId}/centre/voip/token`
    );
    return response.data.data;
  },

  async reportInbound(storeId: number, payload: { phone: string; sip_call_id?: string | null }) {
    const response = await apiClient.post<{
      success: boolean;
      data: { call: CentreCall };
    }>(`/stores/${storeId}/centre/voip/calls/inbound`, payload);
    return response.data.data.call;
  },

  async startCall(storeId: number, payload: {
    phone: string;
    contact_name?: string;
    order_id?: number | null;
    telnyx_call_id?: string | null;
    client_dial?: boolean;
  }) {
    const response = await apiClient.post<{
      success: boolean;
      data: { call: CentreCall; from_number: string; dial?: 'server' | 'client' };
    }>(`/stores/${storeId}/centre/voip/calls`, payload);
    return response.data.data;
  },

  async getCall(storeId: number, callId: number) {
    const response = await apiClient.get<{ success: boolean; data: { call: CentreCall } }>(
      `/stores/${storeId}/centre/voip/calls/${callId}`
    );
    return response.data.data.call;
  },

  async claim(storeId: number, callId: number) {
    await apiClient.post(`/stores/${storeId}/centre/voip/calls/${callId}/claim`);
  },

  async accept(storeId: number, callId: number) {
    const response = await apiClient.post<{ success: boolean; data: CentreCall }>(
      `/stores/${storeId}/centre/voip/calls/${callId}/accept`
    );
    return response.data.data;
  },

  async reject(storeId: number, callId: number) {
    await apiClient.post(`/stores/${storeId}/centre/voip/calls/${callId}/reject`);
  },

  async hangup(storeId: number, callId: number) {
    await apiClient.post(`/stores/${storeId}/centre/voip/calls/${callId}/hangup`);
  },

  async event(storeId: number, callId: number, payload: Record<string, unknown>) {
    await apiClient.post(`/stores/${storeId}/centre/voip/calls/${callId}/event`, payload);
  },

  async getRecordingBlob(storeId: number, callId: number) {
    const response = await apiClient.get(`/stores/${storeId}/centre/voip/calls/${callId}/recording`, {
      responseType: 'blob'
    });
    return response.data as Blob;
  }
};

export default centreVoipService;
